<template>
  <div id="adicionar-equipe">
    <div class="d-flex justify-content-end">
      <button class="btn" @click="showModal()">
        <span><i class="icofont-plus"></i> Adicionar equipe</span>
      </button>
    </div>
    <b-modal
      v-model="modal.enabled"
      hide-footer
      centered
      scrollable
      ref="modal"
      id="modal-adicionar-equipe"
    >
      <template #modal-header>
        <div class="d-flex justify-content-between w-100">
          <span>Adicionar equipe</span>
          <span @click="modal.enabled = false">
            <i class="icofont-close" style="cursor: pointer"></i>
          </span>
        </div>
      </template>
      <div class="body">
        <b-input-group>
          <b-form-input
            id="search-input"
            v-model="searchQuery"
            placeholder="CNES"
          ></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="search"
              ><i class="icofont-search-1"></i> Buscar
              <b-spinner
                small
                label="Small Spinner"
                variant="white"
                v-if="loading"
              ></b-spinner
            ></b-button>
          </b-input-group-append>
        </b-input-group>
        <b-alert
          :show="messageAlert.length > 0"
          variant="warning"
          dismissible
          @dismissed="clearMessageAlert"
          class="mt-2"
        >
          {{ messageAlert }}
        </b-alert>

        <div v-if="modal.text != ''" class="mt-3">
          <ValidationObserver ref="observer">
            <ul>
              <li><b>CNES:</b> {{ modal.text.CodigoCNES.codigo }}</li>
              <li><b>UBS:</b> {{ modal.text.nomeFantasia.Nome }}</li>
              <li><b>Latitude:</b> {{ modal.text.Localizacao?.latitude }}</li>
              <li><b>Longitude:</b> {{ modal.text.Localizacao?.longitude }}</li>
              <li>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|min:10|max:10|onlyNumbers"
                >
                  <b>INE:</b
                  ><input
                    type="text"
                    v-model="form.ine"
                    class="form-control"
                    v-inputmask="maskNumbers"
                  />
                  <div class="error">{{ errors[0] }}</div>
                </validation-provider>
              </li>
              <li>
                <b>Tipo da equipe:</b>
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ required: { allowFalse: false } }"
                >
                  <label
                    v-for="option in optionsTipoEquipe"
                    :key="option.value"
                  >
                    <input
                      type="radio"
                      v-model="form.tipo_equipe"
                      :value="option.value"
                      @change="onChangeTipoEquipe()"
                      class="ml-2"
                    />
                    {{ option.text }}
                  </label>
                  <div class="error">{{ errors[0] }}</div>
                </validation-provider>
              </li>
              <li>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|onlyNumbers"
                >
                  <b>Parâmetro de cadastros:</b
                  ><input
                    type="text"
                    v-model="form.min_cad"
                    class="form-control"
                    v-inputmask="maskNumbers"
                  />
                  <div class="error">{{ errors[0] }}</div>
                </validation-provider>
              </li>
              <li>
                <b>Cadastros no SISAB:</b
                ><input
                  type="text"
                  v-model="form.cad_sisab"
                  class="form-control"
                  v-inputmask="maskNumbers"
                />
              </li>
              <li>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|onlyNumbers"
                >
                  <b>Quantidade máxima de cadastros:</b
                  ><input
                    type="text"
                    v-model="form.max_cad"
                    class="form-control"
                    v-inputmask="maskNumbers"
                  />
                  <div class="error">{{ errors[0] }}</div>
                </validation-provider>
              </li>
            </ul>
            <div class="d-flex justify-content-end">
              <button class="btn mt-3" @click="salvarEquipe()">
                <i class="icofont-plus"></i> Adicionar
                <b-spinner
                  small
                  label="Small Spinner"
                  variant="white"
                  v-if="loadingForm"
                ></b-spinner>
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import Masks from '@/mixins/masks'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  name: 'AdicionarEquipe',
  data() {
    return {
      modal: {
        enabled: false,
        text: '',
      },
      searchQuery: '',
      messageAlert: '',
      loading: false,
      optionsTipoEquipe: [
        { text: 'eSF', value: 'eSF' },
        { text: 'eAP-20h', value: 'eAP-20h' },
        { text: 'eAP-30h', value: 'eAP-30h' },
      ],
      form: {
        uf: '',
        ibge: '',
        cnes: '',
        no_municipio: '',
        ine: '',
        no_ubs: '',
        tipo_equipe: '',
        min_cad: '',
        cad_sisab: '',
        max_cad: '',
        latitude: '',
        longitude: '',
        update_from_cnes: '',
      },
      loadingEquipes: false,
      loadingForm: false,
    }
  },
  computed: {
    maskNumbers() {
      return Masks['number']
    },
  },
  methods: {
    showModal() {
      this.form.ine = ''
      this.form.tipo_equipe = ''
      this.form.min_cad = ''
      this.form.cad_sisab = ''
      this.form.max_cad = ''
      this.modal.enabled = true
    },
    async search() {
      this.messageAlert = ''

      if (this.searchQuery.trim() === '') {
        this.messageAlert = 'Por favor, insira um CNES para pesquisar.'
        return
      }

      try {
        this.loading = true
        this.modal.text = ''
        const response = await this.$api.get(
          '/app/profissionais-pec-cnes-datasus/estabelecimentos-de-saude/' +
            this.searchQuery
        )
        if (response != undefined) {
          this.modal.text = response.data.DadosGeraisEstabelecimentoSaude

          this.form.uf =
            response.data.DadosGeraisEstabelecimentoSaude.Endereco.Municipio.UF.siglaUF
          this.form.ibge =
            response.data.DadosGeraisEstabelecimentoSaude.Endereco.Municipio.codigoMunicipio
          this.form.cnes =
            response.data.DadosGeraisEstabelecimentoSaude.CodigoCNES.codigo
          this.form.no_municipio =
            response.data.DadosGeraisEstabelecimentoSaude.Endereco.Municipio.nomeMunicipio
          this.form.no_ubs =
            response.data.DadosGeraisEstabelecimentoSaude.nomeFantasia.Nome
          if (
            response.data.DadosGeraisEstabelecimentoSaude.Localizacao ==
            undefined
          ) {
            this.form.latitude = null
            this.form.longitude = null
          } else {
            this.form.latitude =
              response.data.DadosGeraisEstabelecimentoSaude.Localizacao.latitude
            this.form.longitude =
              response.data.DadosGeraisEstabelecimentoSaude.Localizacao.longitude
          }
          this.form.update_from_cnes =
            response.data.DadosGeraisEstabelecimentoSaude.dataAtualizacao
        } else {
          this.messageAlert = 'Nenhuma equipe encontrada'
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async onChangeTipoEquipe() {
      try {
        this.optionsEquipes = []
        this.form.min_cad = ''
        this.form.max_cad = ''
        this.loadingEquipes = true
        let response = await this.$apiPublic.get(
          `/cofinanciamento-2024/ubs/${this.form.ibge}/tipo-equipe/${this.form.tipo_equipe}`
        )
        if (response) {
          this.form.min_cad = response.data.min_cad
          this.form.max_cad = response.data.max_cad
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingEquipes = false
      }
    },

    async salvarEquipe() {
      try {
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.loadingForm = true
          let response = await this.$api.post(
            '/app/diagnostico-situacional/adicionar-equipe',
            {
              ...this.form,
              cod_ibge: this.$store.state.cod_ibge, // usado para passar no middleware da api
            }
          )
          if (response.data.error == false) {
            this.$toast.success(response.data.message, 'Sucesso:', {
              position: 'topRight',
            })
          } else {
            this.$toast.error(response.data.message, 'Erro:', {
              position: 'topRight',
            })
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingForm = false
      }
    },

    clearMessageAlert() {
      this.messageAlert = ''
    },
  },
}
</script>

<style scoped lang="scss">
#adicionar-equipe {
  margin: 20px;
}
</style>

<style>
#modal-adicionar-equipe ul li {
  margin-top: 5px;
}
</style>
